// basic libs, die ganz oben geladen werden sollen
// deshalb auch der Dateiname "a-basic-lib.js"

//SET CURSOR POSITION
$.fn.setCursorPosition = function (pos) {
	this.each(function (index, elem) {
		if (elem.setSelectionRange) {
			elem.setSelectionRange(pos, pos);
		} else if (elem.createTextRange) {
			var range = elem.createTextRange();
			range.collapse(true);
			range.moveEnd('character', pos);
			range.moveStart('character', pos);
			range.select();
		}
	});
	return this;
};

//SELECT TEXT RANGE
$.fn.selectRange = function (start, end) {
	return this.each(function () {
		if (this.setSelectionRange) {
			this.focus();
			this.setSelectionRange(start, end);
		} else if (this.createTextRange) {
			var range = this.createTextRange();
			range.collapse(true);
			range.moveEnd('character', end);
			range.moveStart('character', start);
			range.select();
		}
	});
};


/* // @see <head>
// feature detect touch devices
function isTouchDevice(){
    return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
}
*/






/* ------------------------------------------------------------------------------------------------------------------ */

// Console-polyfill. MIT license.
// https://github.com/paulmillr/console-polyfill
// Make it safe to do console.log() always.
(function (global) {
	'use strict';
	if (!global.console) {
		global.console = {};
	}
	var con = global.console;
	var prop, method;
	var dummy = function () {
	};
	var properties = ['memory'];
	var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
		'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
		'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',');
	while (prop = properties.pop()) if (!con[prop]) con[prop] = {};
	while (method = methods.pop()) if (!con[method]) con[method] = dummy;
	// Using `this` for web workers & supports Browserify / Webpack.
})(typeof window === 'undefined' ? this : window);





/* ------------------------------------------------------------------------------------------------------------------ */
function hasPointerEvents () {
	var element = document.createElement('x');
	element.style.cssText = 'pointer-events:auto';
	return element.style.pointerEvents === 'auto';
}


/* ------------------------------------------------------------------------------------------------------------------ */
function hasCssCalc () {
	var prop = 'width:';
    var value = 'calc(10px);';
    var element = document.createElement('a');
    element.style.cssText = prop + ['',''].join(value + prop);
    return !!element.style.length;
}

/* ------------------------------------------------------------------------------------------------------------------ */
function getScrollbarWidth () {
	var innerWidth = window.document.documentElement['clientWidth'], // == $(window).innerWidth();
		outerWidth = window.innerWidth; // == $(window).outerWidth();
	if (outerWidth > innerWidth) {
		return outerWidth - innerWidth;
	} else {
		return 0;
	}
}

function bodyScrollLock () {
	var scrollY = '-' + window.scrollY + 'px',
		scrollbarWidth = getScrollbarWidth();
	document.documentElement.style.position = document.body.style.position = 'fixed'; // html / body
	document.documentElement.style.width = document.body.style.width = '100%'; // html / body
	// compensate scrollbar width to avoid jittering content // cannot apply here b/c hotline badge
	document.body.style.paddingRight = scrollbarWidth + 'px';
	// custom code for fixed header
	// $('.shop-header-default').css('paddingRight', scrollbarWidth + 'px'); // cannot apply here b/c hotline badge
	// / custom code for fixed header
	// console.log(scrollY);
	document.body.style.top = scrollY;
}

function bodyScrollUnlock () { // mobile menu closes
	if ( document.documentElement.style.position == 'fixed' ) { // unlock only if previously locked
		var scrollY = document.body.style.top;
		document.documentElement.style.position = document.body.style.position = 'static'; // html / body
		window.scrollTo(0, parseInt(scrollY || '0') * -1);
		document.body.style.paddingRight = '0'; // cannot apply here b/c hotline badge
		// custom code for fixed header
		// $('.shop-header-default').css('paddingRight', 0); // cannot apply here b/c hotline badge
		// / custom code for fixed header
	}
}

/* ------------------------------------------------------------------------------------------------------------------ */

